import { nanoid } from "@reduxjs/toolkit"

export const routeData = [
    {
        id: nanoid(),
        locationData: {
            il: "",
            ilce: "",
            lat: "",
            lng: "",
            location: "",
            bolge: "",
            ilId: "",
            ilceId: ""
        },
        adres: "",
        adresTarif: "",
        adresKaydedilsinMi: false,
        adresBaslik: "",
        date: "",
        dateEngec: "",
        saatBaslangic: "",
        saatBitis: "",
        saatAllTime: false,
        locationType: "yukleme",
        order: 1,
        sevkBicimleri:[
            {
                id: 1,
                name: "Forkliftle",
                status: false,
            },
            {
                id: 2,
                name: "Rampadan",
                status: false,
            },
            {
                id: 3,
                name: "Vinçle",
                status: false,
            },
            {
                id: 4,
                name: "Elle",
                status: false,
            },
            {
                id: 5,
                name: "Dökme",
                status: false,
            },
            {
                id: 6,
                name: "Yandan",
                status: false,
            },
            {
                id: 7,
                name: "Babalar Çıksın",
                status: false,
            }
        ]
    },
    {
        id: nanoid(),
        locationData: {
            il: "",
            ilce: "",
            lat: "",
            lng: "",
            location: "",
            bolge: "",
            ilId: "",
            ilceId: ""
        },

        adres: "",
        adresTarif: "",
        adresKaydedilsinMi: false,
        adresBaslik: "",
        date: "",
        dateEngec: "",
        saatBaslangic: "",
        saatBitis: "",
        saatAllTime: false,
        locationType: "bosaltma",
        order: 2,
        sevkBicimleri:[
            {
                id: 1,
                name: "Forkliftle",
                status: false,
            },
            {
                id: 2,
                name: "Rampadan",
                status: false,
            },
            {
                id: 3,
                name: "Vinçle",
                status: false,
            },
            {
                id: 4,
                name: "Elle",
                status: false,
            },
            {
                id: 5,
                name: "Dökme",
                status: false,
            },
            {
                id: 6,
                name: "Yandan",
                status: false,
            },
            {
                id: 7,
                name: "Babalar Çıksın",
                status: false,
            }
        ]
    }
]

export const paymentData = {
    hedefNakliyefiyat: "",
    fiyatlandirmaType: {
        value: 0,
        text: "TL"
    },
    fiyatYayinlansin: true,
    odemeSekli: {
        value: "",
        text: ""
    },
    odemeSekliDigerAciklama: "",
    yakitDurumu: {
        value: "",
        text: ""
    },
    yakitOrani: "",
    komisyonDurumu: {
        value: "",
        text: ""
    },
    komisyonMiktari: ""
}


export const yukData = {
    //! options
    yuklemeTuru: {
        value: "",
        text:""
    },

    //! text
    yukTuru: "",

    //! bool
    yukADR: false,
    yukAdrDescription: "",

    agirlikBirim: {
        value: "",
        text: ""
    },
    toplamAgirlik: "",
    toplamHacim: "",
    yukDesc: "",
    yukunDegeri: "",
    companyLoadNumber: "",
    customsPlace: "",
    vesselDate: "",
    isFreeZone: false
}

export const aracData = {
    aracSayisi: 1,
    aracTypeName: "",
    aracTypeId: "",
    kasaTypeName: "",
    kasaTypeId: "",
    kasaTypeOptions: [], 
    zeminType: {
        value: "",
        text: ""
    },
    digerOzellikler: ""
}

 
export const paketlemeTypes = [
    {
        id: 1,
        name: "Palet",
        isOpen: true,           //! bu ekranda görünüp görünmeyeceğini belirler
        isOther: false          //! bu diğerlerinin içinde görünüp görünmeyeceğini belirler  
    },
    {
        id:2,
        name: "Kutu",
        isOpen: true,
        isOther: false
    },
    {
        id: 3,
        name: "Dökme",
        isOpen: true,
        isOther: false
    },

    {
        id: 4,
        name: "Big Bag",
        isOpen: false,
        isOther: true
    },
    {
        id: 5,
        name: "Varil Bidon",
        isOpen: false,
        isOther: true
    },
    {
        id: 6,
        name: "Teneke",
        isOpen: false,
        isOther: true
    },
    {
        id: 7,
        name: "IBC",
        isOpen: false,
        isOther: true
    },
    {
        id: 0,
        name: "Diğer",
        isOpen: false,
        isOther: true
    },
]

export const paketlemeData = [
    {
        id: nanoid(),
        activePaketlemeTypeId: 1,
        paketlemeType: "Palet",
        ustUsteYuklenmesin: false,
        ustUsteMiktar: 0,
        list:[
                {
                    id:nanoid(),
                    en: 120,
                    boy: 80,
                    yukseklik: "",
                    agirlik:"",
                    sayisi:""
                }
            ]
    }
]
